/**
 * Admin V3 — Drivers — Identity Panel (Plan §2.2 M-F-5).
 * Read-only display of identity fields (first_name, last_name, dob, address,
 * nationality + legacy email/phone/vehicle). Editing happens elsewhere.
 */
import React from 'react';
import { User } from 'lucide-react';
import { SectionCard } from '../../shared/visualTokens';
import { t } from '../../i18n';

const Row = ({ labelKey, value, locale }) => (
  <div className="flex justify-between border-b border-slate-100 py-2 text-sm">
    <span className="text-slate-500">{t(labelKey, locale)}</span>
    <span className="text-slate-900 text-right">
      {value || <span className="text-slate-400 italic">{t('compliance.identity.empty', locale)}</span>}
    </span>
  </div>
);

const formatDate = (v) => {
  if (!v) return null;
  try { return new Date(v).toISOString().slice(0, 10); } catch { return String(v); }
};

const DriverIdentityPanel = ({ driver, locale = 'fr' }) => (
  <SectionCard
    icon={User}
    iconClass="bg-blue-100 text-blue-700"
    title={t('compliance.identity.title', locale)}
  >
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8" data-testid="driver-identity-panel">
      <Row labelKey="compliance.identity.field.first_name"      value={driver.first_name} locale={locale} />
      <Row labelKey="compliance.identity.field.last_name"       value={driver.last_name}  locale={locale} />
      <Row labelKey="compliance.identity.field.email"           value={driver.email}      locale={locale} />
      <Row labelKey="compliance.identity.field.phone"           value={driver.phone}      locale={locale} />
      <Row labelKey="compliance.identity.field.dob"             value={formatDate(driver.dob)} locale={locale} />
      <Row labelKey="compliance.identity.field.address"         value={driver.address}    locale={locale} />
      <Row labelKey="compliance.identity.field.nationality"     value={driver.nationality} locale={locale} />
      <Row labelKey="compliance.identity.field.vehicle_model"   value={driver.vehicle_model} locale={locale} />
      <Row labelKey="compliance.identity.field.license_plate"   value={driver.license_plate} locale={locale} />
      <Row labelKey="compliance.identity.field.lifecycle_state" value={driver.lifecycle_state} locale={locale} />
    </div>
  </SectionCard>
);

export default DriverIdentityPanel;
